export enum ETypSeznam {
    OVERENY = 'OVERENY',
    SMAZANY = 'SMAZANY',
    ZAEVIDOVANY = 'ZAEVIDOVANY'
}
